// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"video_videoWrapper__3Jiaw","videoResponsive":"video_videoResponsive__2ucIk"};